import TopBar from '../components/topbar';
import PopupContext, { PopupProvider } from '../context/context-popup';
import Row from '../components/row';
import Sidebar from '../components/sidebar';
import ThemeContext, { ThemeProvider } from '../context/context-theme';
import { createRef, useContext, Component } from 'react';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LayoutLoading from './layout-loading';
import PopupsOnboarding from '../views/dashboard/popups/popups-onboarding';

const Providers = ({ children, theme, topTheme }) => {
    return (
        <ThemeProvider theme={theme} topTheme={topTheme}>
            <PopupProvider>
                { children }
            </PopupProvider>
        </ThemeProvider>
    )
}

class OnBoarding extends Component {
    static contextType = PopupContext;

    componentDidMount() {
        const website = document.querySelector('.website');

        const onBoarding = website?.getAttribute("data-onboarding");
        const onboardingOwner = website?.getAttribute("data-onboarding-owner")
    
        if (onBoarding || onboardingOwner) {
            this.context.setPopup(<PopupsOnboarding />);
        }
    }

    render() {
        return null;
    }
}

export default function Layout({ className = '', onlyContent = false, children, theme = 'dark', loading = false, topLeft = null, topRight = null, topBarRef = createRef(), middle = null, bottom = null }) {
    return (
        <Providers theme={theme}>
            { !onlyContent && 
                <>
                    <Sidebar/>
                    <ToastContainer
                        position="bottom"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                    />
                </>
            }
            <OnBoarding/>
            <LayoutLoading loading={loading}>
                <div className={`content ${className}`}>
                    { !onlyContent && <TopBar /> }
                    <div className="layout-container">
                        { (topLeft || topRight) && <div className="layout__topbar" ref={topBarRef}>
                            { topLeft }
                            { topRight }
                        </div> }

                        { middle && <div className="layout">
                            <div className="layout__middle">{ middle }</div>
                        </div> }

                        <div className="layout">
                            { children }
                        </div>

                        <div className="layout">
                            { bottom }
                        </div>
                    </div>
                </div>
            </LayoutLoading>
        </Providers>
    )
}
